import { useCallback, useState } from "react";
import { Workspace } from "../../../types/files";
import AddEditCompanyModal from "../companies/AddEditCompanyModal";
import AddCompaniesToInvestorModal from "./AddCompaniesToInvestorModal";
import { collectionKey } from "../../pages/InvestorsPage";

const AddCompaniesToInvestorLoaderModal: React.FC<{
    isOpen: boolean,
    workspace?: Workspace,
    onClose: () => void,
}> = ({ isOpen, workspace, onClose }) => {
    const [addCompanyModalOpen, setAddCompanyModalOpen] = useState<boolean>(false);

    const handleOpenModal = useCallback((field: string) => {
        switch (field) {
            case 'Add company':
            default:
                setAddCompanyModalOpen(true);
                break;
        }
    }, []);

    return (<>
        <AddCompaniesToInvestorModal
            isOpen={isOpen}
            workspace={workspace}
            onOpenModal={handleOpenModal}
            onClose={onClose} />
        {addCompanyModalOpen && (
            <AddEditCompanyModal
                isOpen={addCompanyModalOpen}
                collectionKey={collectionKey}
                onClose={() => setAddCompanyModalOpen(false)}
            />
        )}
    </>);
}

export default AddCompaniesToInvestorLoaderModal;
